import { getHeadlineWithBgTemplate } from "../../shortcodes/templates";
import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";

const headlineWithBgCTAConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Headline Settings #1",
    body: {
      type: "panel",
      items: [
        {
          type: "textarea",
          name: "headlineText",
          label: "Headline text",
          placeholder: "Headline text",
        },
        {
          type: "colorinput",
          name: "bgColor",
          label: "Headline background color",
        },
        {
          type: "checkbox",
          name: "enableBackgroundColor",
          label: "Enable background color",
        },
        {
          type: "colorinput",
          name: "bordersColor",
          label: "Borders color",
        },
        {
          type: "checkbox",
          name: "enableBorders",
          label: "Enable borders",
        },
      ],
    },
    initialData: {
      bgColor: "#0543F0",
      bordersColor: "#E6E6E6",
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getHeadlineWithBgTemplate({
        text: data.headlineText,
        bgColor: data.bgColor,
        enableBackgroundColor: data.enableBackgroundColor,
        bordersColor: data.bordersColor,
        enableBorders: data.enableBorders,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api, false);
      api.close();
    },
  });
};

export { headlineWithBgCTAConfig };
